import React from 'react';
import { ATCONSTANTS as ATC } from 'appconstants';

class ContentHeader extends React.Component {
  render() {
    const { title, ariaLevel, children } = this.props;
    return (
      <>
        <div className="float-right" />
        <div
          data-id={`${ATC.APP}TITLE_TEXT{ATC.DIV}`}
          className="content-page-title border"
          role="heading"
          aria-level={ariaLevel}
        >
          {title}
          {children}
        </div>
      </>
    );
  }
}

export default ContentHeader;
